<template>
  <div id="app">
    <div class="nav-bar">
      <h1><span style="color:#fcd747">traintraintrain</span> dashboard</h1>
      <h2 v-if="currentTime">{{ currentTime.format("Do MMMM YYYY") }}</h2>
      <div v-if="currentTime">{{ currentTime.format("h:mm:ss a") }}</div>
    </div>
    <div class="container">

<!--       <div class="viz">
        <trainmap :train-status-data="trainStatusData" :id-to-p-v="idToPV"></trainmap>
      </div> -->

      <div class="viz">
        <marey :train-history-data="trainHistoryData" :id-to-p-v="idToPV"></marey>
      </div>

      <div v-for="train in trains" class="card">
        <h2>{{ idToPV[train.id] }}</h2>
        <p>Updated {{ train.current_station.timestamp }}</p>
        <h3>Currently at:</h3>
        <div class="location">
          <p v-if="train.previous_stations" class="text-bold">{{ train.current_station.station }}</p>
          <p v-else class="text-bold">Sengkang Depot</p>
        </div>
        <div v-if="train.previous_stations && train.previous_stations.length > 0">
          <h3>Previous stations:</h3>
            <div v-for="station in train.previous_stations.slice(0, 3)" class="location">
              <div class="text-bold">{{ station.station }}</div>
              <div v-if="station.first_seen">Entered: {{ station.first_seen | formatDate }}</div>
              <div v-if="station.last_seen">Departed: {{ station.last_seen | formatDate }}</div>
            </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment-timezone'
import _ from 'lodash'
import axios from 'axios'
import Marey from './components/Marey'
import Trainmap from './components/Trainmap'
import Vue from 'vue'

Vue.component('marey', Marey)
Vue.component('trainmap', Trainmap)

export default {
  name: 'app',
  mounted() {
    // Update train and datetime every few seconds
    this.updateTrains()
    setInterval(this.updateTrains, 3000)
    setInterval(this.updateDateTime, 1000)
    Promise.resolve(fetchTrainHistoryData()).then(data => {
      this.trainHistoryData = data
    })
    setInterval(() => {
      Promise.resolve(fetchTrainHistoryData()).then(data => {
        this.trainHistoryData = data
      })
    }, 3000)
  },
  data() {
    return {
      currentTime: null,
      trainStatusData: null,
      trainHistoryData: null,
      trains: [],
      idToPV: {
        "bff0dc76686626eca31e1dcb18ecfe11": "Train 1",
        "e709026bc78974b75fe136241e9692f8": "Train 2",
        "d95fdb0b465841c6c53c54b5012c95bc": "Train 3",
        "6e25ad64d486ffa6b01eb5630fe711ab": "Train 4",
        "e2779d9a5ff9b1c5a7fc5634503a0ce4": "Train 5"
      }
    }
  },
  methods: {
    updateDateTime() {
      this.currentTime = moment.tz("Singapore")
    },
    updateTrains() {
      fetchTrainStatusData().then(this.processTrainStatusData)
    },
    processTrainStatusData(raw_data) {
      let vm = this
      this.trainStatusData = raw_data
      this.trains = _.map(raw_data, function(train) {
        train["timestamp"] = moment.tz(train["timestamp"], "Singapore")
        train["seconds_last_seen"]  = vm.currentTime - train.timestamp
        train.current_station.timestamp = moment(train.current_station.timestamp).fromNow()
        return train
      })
    }
  },
  filters: {
    formatDate: function (date) {
      if (!date) return
      return moment(date).format("h:mm:ss a")
    }
  }
}

function fetchTrainStatusData() {

  // Base API url for getting train status
  let url = "https://lvz9c27o80.execute-api.ap-southeast-1.amazonaws.com/v1/status?id="

  let response_promise = getAllTrainDataFrom(url)

  let data = response_promise.then(function(responses) {
    // Filter responses that are not valid trains
    let output_data = _.filter(responses, function(o) {
      return o.data.hasOwnProperty("current_station")
    })

    // Flatten the responses by extracting data
    let result = _.map(output_data, function(i) {
      return i.data
    })
    return result

  }).catch(function(error) {
    console.log(error)
  })

  return Promise.resolve(data)
}

function fetchTrainHistoryData() {
  let url = "https://lvz9c27o80.execute-api.ap-southeast-1.amazonaws.com/v1/previous-stations?timeframe=90&id="

  return Promise.resolve(getAllTrainDataFrom(url).then(responses => {
    return responses
            .filter(response => response.status === 200)
            .map(response => response.data.results)
  }))
}

function getAllTrainDataFrom(url) {
  let requests = []
  let train_ids = getTrainIDs()

  _.map(train_ids, train_id => {
    requests.push(axios.get(url + train_id))
  })

  return Promise.all(requests)
}

function getTrainIDs() {
  return [
    "bff0dc76686626eca31e1dcb18ecfe11",
    "e709026bc78974b75fe136241e9692f8",
    "d95fdb0b465841c6c53c54b5012c95bc",
    "6e25ad64d486ffa6b01eb5630fe711ab",
    "e2779d9a5ff9b1c5a7fc5634503a0ce4"
    // "b8671638f155b43f2341f71beee54088"
  ]
}

</script>

<style lang="scss">
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.is-hidden {
  display: none;
}

h1, h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}

body {
  margin: 0px;
  background-color: #FCFFF5;
}
.nav-bar {
  padding: 1em;
  background-color: #193441;
  color: white;
}
.container {
  display: flex;
  flex-wrap: wrap;
}
.card {
  flex-grow: 1;
  background-color: #91AA9D;
  padding: 1.5em;
  margin: 1em;

}
.location{
  margin-bottom: 20px;
  background-color: white;
  text-align: center;
  padding: 20px;
}
.active {
  color: green;
}
.inactive {
  color: red;
}

.text-bold {
  font-weight: bold;
}

.viz {
  padding-bottom: 40px;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue